import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RfqQuoteComponent } from './rfq-quote/rfq-quote.component';
import { LeadManagementComponent } from './lead-management/lead-management.component';
import { CreateRfqComponent } from './create-rfq/create-rfq.component';
import { CustomerAuthGaurd } from '../../auth/auth.guard';
import { IndirectMaterialComponent } from './indirect-material/indirect-material.component';

const routes: Routes = [
  {
    path: 'quote',
    component: RfqQuoteComponent,
    canActivate: [CustomerAuthGaurd],
  },
  {
    path: '',
    component: LeadManagementComponent,
    canActivate: [CustomerAuthGaurd],
  },
  {
    path: 'create-rfq/:id',
    component: CreateRfqComponent,
    canActivate: [CustomerAuthGaurd],
  },
  {
    path: 'create-rfq',
    component: CreateRfqComponent,
    canActivate: [CustomerAuthGaurd],
  },
  {
    path: 'indirect-material',
    component: IndirectMaterialComponent,
    canActivate: [CustomerAuthGaurd],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RfqRoutingModule {}
